import { IconBoxProps } from "./props"
import { IconContainer } from "./styled"
import { getColor } from "./utils/getColor"

const IconBox = ({ size, color, children, onClick }: IconBoxProps) => {
  const bg = getColor(color)
  return (
    <IconContainer bgColor={bg} containerSize={size} onClick={onClick}>
      {children}
    </IconContainer>
  )
}

export default IconBox
